import { Address } from 'wagmi'

// collections that use `walletOfOwner` but not ERC721Enumerable
export const COLLECTIONS_WITH_WALLET_OF_OWNER: Address[] = ['0x611747CC4576aAb44f602a65dF3557150C214493']
